// 接入文档：https://cooper.didichuxing.com/docs/document/2200553116152
import { initSign } from '@didi/wsgsig'
initSign({
  env: 'ame',
  bizId: '2d0d6dcb76ffd91e8d734891a0869349',
  appVer: '1.0.0',
  os: '4',
})
